import React, { createContext, useContext, useState, useEffect } from 'react';

// Create the MultiHOA Context
export const MultiHOAContext = createContext();

// Custom hook to use the MultiHOAContext
export const useMultiHOA = () => {
  const context = useContext(MultiHOAContext);
  if (!context) {
    throw new Error('useMultiHOA must be used within a MultiHOAProvider');
  }
  return context;
};

// MultiHOA Provider Component
export const MultiHOAProvider = ({ children }) => {
  const [activeHoaId, setActiveHoaIdState] = useState(() => {
    return localStorage.getItem('active_hoa_id') || null;
  });

  const [activePropertyId, setActivePropertyIdState] = useState(() => {
    return localStorage.getItem('active_property_id') || null;
  });

  const [userHoas, setUserHoas] = useState([]);
  const [userProperties, setUserProperties] = useState([]);

  // Wrapper to update both state and localStorage
  const setActiveHoaId = (hoaId) => {
    if (hoaId) {
      localStorage.setItem('active_hoa_id', String(hoaId)); // Always store as string
    } else {
      localStorage.removeItem('active_hoa_id');
    }
    setActiveHoaIdState(hoaId);
  };

  const setActivePropertyId = (propertyId) => {
    if (propertyId) {
      localStorage.setItem('active_property_id', String(propertyId)); // Always store as string
    } else {
      localStorage.removeItem('active_property_id');
    }
    setActivePropertyIdState(propertyId);
  };

  // Clear context (on logout)
  const clearContext = () => {
    localStorage.removeItem('active_hoa_id');
    localStorage.removeItem('active_property_id');
    setActiveHoaIdState(null);
    setActivePropertyIdState(null);
    setUserHoas([]);
    setUserProperties([]);
  };

  const value = {
    activeHoaId,
    setActiveHoaId,
    activePropertyId,
    setActivePropertyId,
    userHoas,
    setUserHoas,
    userProperties,
    setUserProperties,
    clearContext
  };

  return (
    <MultiHOAContext.Provider value={value}>
      {children}
    </MultiHOAContext.Provider>
  );
};

export default MultiHOAContext;
